import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _styled from "styled-components";
import { forwardRef } from "react";
import cn from "classnames";
import styled from "styled-components";
import { NumberNotification } from "@crehana/compass.notification/dist/NotificationsDrawer/components";
import { Tooltip } from "@crehana/ui";
import { useMainMenuContext } from "../hooks";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var StyledButton = /*#__PURE__*/styled.button.withConfig({
  componentId: "sc-24v3s-0"
})(["\n  & > svg {\n    top: 4px;\n    left: ", ";\n    transition: ", ";\n  }\n  & .outline-icon {\n    opacity: 1;\n  }\n  & .filled-icon {\n    opacity: 0;\n  }\n  &:hover {\n    & .outline-icon {\n      opacity: 0;\n    }\n    & .filled-icon {\n      opacity: 1;\n    }\n  }\n"], function (props) {
  return props.newSidebarEnabled ? '8px' : '4px';
}, function (_ref) {
  var theme = _ref.theme;
  return theme.transition('opacity');
});
var NavbarIconButtonWithHover = function NavbarIconButtonWithHover(_ref2, ref) {
  var _Icon, _FilledIcon;
  var className = _ref2.className,
    Icon = _ref2.Icon,
    FilledIcon = _ref2.FilledIcon,
    label = _ref2.label,
    _ref2$numberNotificat = _ref2.numberNotification,
    numberNotification = _ref2$numberNotificat === void 0 ? 0 : _ref2$numberNotificat,
    href = _ref2.href,
    onClick = _ref2.onClick,
    dataTour = _ref2.dataTour;
  var _useMainMenuContext = useMainMenuContext(),
    theme = _useMainMenuContext.theme,
    themeName = _useMainMenuContext.themeName,
    layoutConfig = _useMainMenuContext.layoutConfig;
  var newSidebarEnabled = !!layoutConfig.newSidebarEnabled;
  var renderIcon = function renderIcon() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [_Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
        size: 24,
        "aria-hidden": true,
        ignoreColor: true,
        className: "outline-icon fill-current absolute"
      })), _FilledIcon || (_FilledIcon = /*#__PURE__*/_jsx(FilledIcon, {
        size: 24,
        "aria-hidden": true,
        ignoreColor: true,
        className: "filled-icon fill-current absolute"
      })), numberNotification > 0 && /*#__PURE__*/_jsx(_StyledNumberNotification, {
        className: "absolute",
        number: numberNotification,
        $_css: newSidebarEnabled ? 'right: 0px; border: 1px solid white;' : 'right: -6px;'
      })]
    });
  };
  var baseButtonProps = {
    className: cn('flex items-center justify-center relative flex-shrink-0', theme.nav.iconWithHoverColorClassName, className, newSidebarEnabled ? 'w-40 h-32 hover:bg-gray-lighter rounded-5' : 'w-32 h-32'),
    onClick: onClick,
    'aria-label': label,
    'data-tour': dataTour
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    label: label,
    position: "bottom",
    isDark: themeName.nav === 'dark' || themeName.nav === 'light' && newSidebarEnabled,
    children: href ? /*#__PURE__*/_jsx(StyledButton, _objectSpread(_objectSpread({
      as: "a",
      href: href,
      newSidebarEnabled: newSidebarEnabled,
      ref: ref
    }, baseButtonProps), {}, {
      children: renderIcon()
    })) : /*#__PURE__*/_jsx(StyledButton, _objectSpread(_objectSpread({
      newSidebarEnabled: newSidebarEnabled,
      type: "button",
      ref: ref
    }, baseButtonProps), {}, {
      children: renderIcon()
    }))
  });
};
export default /*#__PURE__*/forwardRef(NavbarIconButtonWithHover);
var _StyledNumberNotification = /*#__PURE__*/styled(NumberNotification).withConfig({
  componentId: "sc-24v3s-1"
})(["\n            top: -6px;\n            ", "\n          "], function (p) {
  return p.$_css;
});